export var GcpSqlVmSetupPath;
(function (GcpSqlVmSetupPath) {
    GcpSqlVmSetupPath["GCP_SQL_VM_SETUP_PATH_OBJECT_STORAGE"] = "OBJECT_STORAGE";
    GcpSqlVmSetupPath["GCP_SQL_VM_SETUP_PATH_DISK"] = "DISK";
})(GcpSqlVmSetupPath || (GcpSqlVmSetupPath = {}));
